<template>
    <!--我的红包页面-->
    <div class="box">
        <!--<div class="packetBox boxSizing" :class="iftimeout ? 'timeout' : 'timein'" v-for="item in myPacket">-->
            <!--<div class="packTop clearfix">-->
                <!--<div class="packFl fl">-->
                    <!--<div class="packPrice">￥<span v-text="item.price"></span></div>-->
                    <!--<div class="packTotal">满<span v-text="item.small_price"></span>可用</div>-->
                <!--</div>-->
                <!--<div class="packMid fl">-->
                    <!--<div class="packMidTop oneEllipsis" v-text="item.rb_name"></div>-->
                    <!--<div><span v-text="item.begin_time"></span> - <span v-text="item.end_time"></span></div>-->
                <!--</div>-->
                <!--<router-link class="packState fr" v-if="!iftimeout" :to="{path:'/'}">去使用</router-link>-->
            <!--</div>-->
            <!--<div class="packetBot oneEllipsis" v-text="item.info">仅可购买财经专业下沃米商城指定产品，下单时自动抵扣</div>-->
        <!--</div>-->
        <mt-loadmore :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" :auto-fill="false" ref="loadmore" distance-index="1" bottom-distance="200" >
            <packet :my-packet="myPacket"></packet>
        </mt-loadmore>
        <div class="noDataPacket" v-if="noDataPacket">您还没有红包哦！</div>
    </div>

</template>

<script>
    import axios from "axios";
    import qs from "qs";
    import moment from "moment/moment.js";
    import packet from "../components/redpacket/packet";
    import common from "../common";

    export default {
        name: "myRedpacket",
        components: {
           packet
        },
        data() {
            return {
                allLoaded:false,
                pageIndex:1,
                pageSize:5,
                myPacket: [],
                noDataPacket: true
                // price: "",
                // begin_time: "",
                // end_time: "",
                // info: "",
                // rb_name: "",
                // small_price: "",
                // status: 1,
                // iftimeout: false,
                // packCss: {
                //     1: 'timein',
                //     2: 'used',
                //     3: 'timeout'
                // }
            }
        },
        created() {
            common.iflogin();
        },
        mounted() {
            this.getMypacket();
        },
        methods: {
            loadBottom(){
                var that = this;
                that.getMypacket(()=>{
                    that.$refs.loadmore.onBottomLoaded();
                });
            },
            getMypacket(callback) {
                var that = this;
                axios.post("/wap/RedBagShow/redBagList",qs.stringify({ page: that.pageIndex, limit: that.pageSize }))
                    .then(res => {
                        console.log(res);
                        var data = res.data.data;

                        if(res.data.data.length === 0){
                            this.allLoaded = true;
                        }else{
                            this.noDataPacket = false; //没数据，提示信息
                            this.pageIndex +=1;
                        }

                        for (var i = 0; i < data.length; i++) {
                            var obj={};
                            obj.price = data[i].price;
                            obj.begin_time = moment(data[i].begin_time).format('YYYY.MM.DD');
                            obj.end_time = moment(data[i].end_time).format('YYYY.MM.DD');
                            obj.info = data[i].info;
                            obj.rb_name = data[i].rb_name;
                            obj.small_price = data[i].small_price;
                            obj.status = data[i].status;
                            obj.stabtn = true;
                            this.myPacket.push(obj);
                           // 判断是否过期
                           //  var today = (new Date()).getTime();//today是当前日期的时间戳
                           //  if (data[i].end_time - today < 0) {
                           //      // console.log(today - data[i].end_time);
                           //      this.iftimeout = true;
                           //  }else{
                           //      this.iftimeout = false;
                           //  }
                        }
                        callback && (typeof(callback) === "function") && callback();
                    }).catch(error => {
                        console.log(error);
                    });
            }
        }
    };
</script>

<style scoped lang="scss">
    .box{
        padding: 30px;
         -webkit-overflow-scrolling: touch;
        height:100vh;
        overflow: scroll;
    }
    /deep/ .mint-loadmore-text{
        font-size: 30px;
    }
    .noDataPacket{
        height: 600px;
        line-height: 600px;
        text-align: center;
        font-size: 30px;
    }
</style>
